import { useState, useEffect } from 'react';

const useAnimatedLoadingText = (text, interval) => {
  const [loadingText, setLoadingText] = useState(text);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setLoadingText((prevText) => {
        if (prevText === text + "...") {
          return text;
        } else {
          return prevText + ".";
        }
      });
    }, interval);

    return () => clearInterval(intervalId);
  }, [text, interval]);

  return loadingText;
};

export default useAnimatedLoadingText;
